
import React, { Component } from 'react';
import { connect } from 'react-redux'

import { IoIosStar } from "react-icons/io";
import CdnImage from "../../../general/cdnImage/cdnImage";

const stateManager = require('../../../../../utils/state/stateManager');
const formatter = require('../../../../../utils/formatter/formatter');
const stringUtil = require('../../../../../utils/string/stringUtil');

class Items extends Component 
{
    render()
    {
        var state = stateManager.getStore().getState();
        var menu = state.currentMenu;

        
        if (menu == null || menu.categories.length <= 0)
            return null;

        var childComponents = [];
        for (var index = 0; index < menu.categories.length; index++)
        {
            if (menu.categories[index].items.length <= 0)
                continue;

            this.renderCategory(menu, index, childComponents);
        }

        return <div style={{marginBottom:'20px'}}>
                    {childComponents}
               </div>
    }

    renderCategory(menu, categoryIndex, childComponents)
    {
        var category = menu.categories[categoryIndex];
        let htmlId = `menu-category-header-${categoryIndex}`;
        childComponents.push(<div id={htmlId} style={{background:`var(--menu-category-background-color)`, 
                                                        color:`var(--menu-category-font-color)`, 
                                                        fontSize:`var(--menu-category-font-size)`, 
                                                        paddingLeft:'10px',
                                                        paddingRight:'10px',
                                                        paddingTop:'20px',
                                                        paddingBottom:'20px',
                                                        fontWeight:'bold'}}>
                                {category.caption}
                             </div>)

        for (var index = 0; index < category.items.length; index++) 
        {
            this.renderItem(categoryIndex, category, index, childComponents);
        }
    }

    renderItem(categoryIndex, category, itemIndex, childComponents)
    {
        var descriptionWidth = Math.round(window.innerWidth * 0.66);
        var imageWidth = Math.round(window.innerWidth  - descriptionWidth);


        var item = category.items[itemIndex];
        var component = <div style={{
                                        marginTop:'20px', 
                                        paddingLeft:'10px',
                                        paddingRight:'10px',
                                        paddingBottom:'20px',
                                        borderBottom: `var(--menu-categories-bottom-border)`,}}
                            onClick={()=>{this.onItemClick(categoryIndex, category, itemIndex, item)}}>
                            <table>
                                <tr>
                                    <td width={`${descriptionWidth}px`}>
                                        <div style={{fontWeight:'bold'}}>
                                            {item.caption}
                                        </div>

                                        <div style={{width:descriptionWidth, overflowWrap:'break-word'}} className='smallText'>
                                            {item.notes}
                                        </div>
                                    </td>
                                    <td width={`${imageWidth}px`}>
                                        {this.renderImage(item)}
                                    </td>
                                </tr>
                            </table>
                            <div style={{marginTop:'5px'}}>
                                            <table>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>
                                                        {this.renderItemPrice(item)}
                                                    </td>
                                                    <td>
                                                        {this.renderIsPopularItemTag(item)}
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                        </div>
                        </div>

        childComponents.push(component);
    }

    renderItemPrice(item)
    {
        if (this.isItemAvailable(item))
            return formatter.convertToCurrencyFormat(item.price);

        return <div>
                    <span style={{textDecoration:'line-through'}}>{formatter.convertToCurrencyFormat(item.price)}</span>
                    <span style={{marginLeft:'5px'}}>Out Of Stock</span>
                </div>
    }

    renderIsPopularItemTag(item)
    {
        if (!item.isPopular)
            return null;

        return <span style={{ 
                                marginLeft:'10px', 
                                display:'inline-flex', 
                                alignItems: 'center', 
                                color:`var(--menu-item-popular-font-color)` }}
               >
                    <IoIosStar/>
                    <span style={{marginLeft:'5px'}}>Popular</span>
                </span>
    }

    renderImage(item)
    {
        var width = Math.round(window.innerWidth * 0.25);
        var height = Math.floor(width * 0.50);
        
        let grayScale = false;
        if (!this.isItemAvailable(item))
            grayScale = true

        if (!stringUtil.isStringNullOrEmpty(item.imageUrl))
        {
            var imageUrl = item.imageUrl;
            imageUrl = stringUtil.replaceAll(imageUrl, 'https://res.cloudinary.com/rms-uat-jinoby/image/upload/', '');
            imageUrl = stringUtil.replaceAll(imageUrl, 'https://res.cloudinary.com/rms-jinoby/image/upload/', '');

            return <div style={{marginLeft:'10px', border:`var(--menu-item-border)`, textAlign:'center'}}>
                        <CdnImage publicId={imageUrl} height={height} width={width} grayScale={grayScale}/>
                    </div>
        }

        return <div style={{marginLeft:'10px', border:`var(--menu-item-border)`, textAlign:'center'}}>
                    <CdnImage publicId="menus/default.menu.image.png" height={height} width={width} grayScale={grayScale}/>
                </div>
    }

    onItemClick(categoryIndex, category, itemIndex, item)
    {
        if (!this.isItemAvailable(item))
            return;

        this.props.onClick(categoryIndex, category, itemIndex, item);
    }

    isItemAvailable(item)
    {
        return item.enabled && !item.isSnoozed;
    }
}

const mapStateToProps = state => 
{
    return { 
        currentMenuCategoryIndex: state.currentMenuCategoryIndex,
    }
}

export default connect(mapStateToProps)(Items)